import React from 'react';

import paymentPageStyles from './paymentPage.module.css';

interface paymentDetailsProps {
  due: string;
  items: number;
  totalPay: string;
  disabled: boolean;
  totalConvenience: string;
  textConvenienceFee: string;
  stripeTax?: string;
};

const paymentDetails = (props: paymentDetailsProps) => {

  return (

    <div className={ [paymentPageStyles.invoiceWrapper, props.disabled? paymentPageStyles.disabledLabelColor : '' ].join(' ') }>

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText }>Current amount due:</div>

        <div className={ paymentPageStyles.invoicePrice }>

          <div>$</div> 
          <div>{ props.due }</div>

        </div>

      </div>

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText} >{ props.textConvenienceFee }</div> 

        <div className={ [paymentPageStyles.invoicePrice].join(' ') }>

          <div>$</div> 
          <div>{ props.totalConvenience }</div>

        </div>

      </div>
      { props.stripeTax && <div className={ paymentPageStyles.invoiceItemsWrapper }>

      <div className={ paymentPageStyles.itemText} >CC charge fee</div> 

        <div className={ [paymentPageStyles.invoicePrice, paymentPageStyles.border].join(' ') }>

          <div>$</div> 
          <div>{ props.stripeTax }</div>

        </div>

      </div> }

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText } />

        <div className={ paymentPageStyles.invoicePrice }>

          <div>$</div> 
          <div>{ props.totalPay }</div>

        </div>

      </div>

    </div>
  );
};

export default paymentDetails;
